import React from 'react';
import { Overlay, Spinner } from '@blueprintjs/core';

const LoadingOverlay = ({ isOpen = false, message = 'Loading...' }) => {
  return (
    <Overlay
      isOpen={isOpen}
      hasBackdrop={true}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      usePortal={true}
      enforceFocus={false}
      backdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } }}
    >
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          marginTop: '80px',
          flexDirection: 'column',
          zIndex: 30,
        }}
      >
        <Spinner size={60}/>
        <div style={{ marginTop: '1rem', color: 'white', fontSize: '1.2rem' }}>{message}</div>
      </div>
    </Overlay>
  );
};

export default LoadingOverlay;
